module.exports = __webpack_public_path__ + "img/29.0c1ed7d8.webp";